import {ISlide} from "./slide";

export interface IWidgetConfig {
    slides: Array<ISlide>
    dismissible: boolean
    consentHtml: string
    type: WidgetType
    imageFallback: string
}

export enum WidgetType {
    Intro = 'Intro',
    Single = 'Single',
    Multiple = 'Multiple',
    Hero = 'Hero'
}

export interface IWidgetState {
    config: IWidgetConfig
    slidesPerView: number
    currentIndex: number
    multipleSlides: Array<ISlide>
    singleSlide: ISlide
    transition: string
    isHidden: boolean
    showContent: boolean
    videoIsPlaying: boolean
}

export class WidgetState implements IWidgetState {
    config: IWidgetConfig = {
        slides: [],
        dismissible: false,
        consentHtml: '',
        type: WidgetType.Single,
        imageFallback: ''
    }
    slidesPerView: number = 1
    currentIndex: number = 0
    multipleSlides: Array<ISlide> = []
    singleSlide!: ISlide
    transition: string = 'vuw-fade'
    isHidden: boolean = true
    showContent: boolean = false
    videoIsPlaying: boolean = false
}